export default function contact7() {
    document.querySelectorAll('.check7_agree').forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.checked = false;
        el.removeAttribute('checked');
    });
}
